export default "__VITE_ASSET__ytXK1MGR__"